import styled from '@shazambanking/sdk/styles/emotion';
import mq from '@shazambanking/sdk/styles/mediaQuery';
import { ThemeState } from '@shazambanking/sdk/types/state';

export const EnrollmentFormWrapper = styled('div')(({ theme }: { theme: ThemeState }) => ({
  // tslint:disable: object-literal-sort-keys
  '.detail-btn-group': {
    '.btn': {
      backgroundImage: 'none',
      borderColor: 'transparent',
      borderImage: 'initial',
      borderRadius: '4px',
      borderStyle: 'solid',
      borderWidth: '1px',
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: theme.typography.input.fontSize,
      [mq.sm.max]: {
        fontSize: theme.typography.input.fontSize
      },
      fontWeight: 'normal',
      lineHeight: '1.42857',
      '.link': {
        color: theme.palette.primary.contrastText,
        textDecoration: 'none',
        ':hover': {
          color: theme.palette.primary.contrastText,
        },
        ':visited': {
          color: theme.palette.primary.contrastText,
        }
      },
      marginBottom: '0px',
      padding: '0.375rem 0.75rem',
      textAlign: 'center',
      touchAction: 'manipulation',
      userSelect: 'none',
      verticalAlign: 'middle',
      whiteSpace: 'nowrap'
    },
    '.btn-default': {
      backgroundImage: 'none',
      borderColor: 'rgb(204, 204, 204)',
      boxShadow: 'none',
      float: 'right',
      fontFamily: theme.typography.fontFamily,
      textShadow: 'none',
      transition: 'none 0s ease 0s'
    },
    height: '30px'
  },
  '.enrollment-desc': {
    fontFamily: theme.typography.fontFamily,
    marginTop: 0,
  },
  '.enrollment-form': {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  '.enrollment-panel': {
    backgroundColor: theme.palette.common.white,
    backgroundImage: 'none',
    borderColor: 'rgb(197, 196, 196)',
    borderImage: 'initial',
    borderRadius: '5px',
    borderStyle: 'solid',
    borderWidth: '1px',
    boxShadow: 'none',
    color: 'rgb(51, 51, 51)',
    marginBottom: '20px',
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '548px',
    padding: '20px'
  },
  '.form-group': {
    ':focus': {
      boxShadow: 'none'
    },
    backgroundColor: theme.palette.common.white,
    border: 'none',
    borderBottom: `0.03125rem solid ${theme.palette.primary.contrastText}`,
    borderRadius: 0,
    caretColor: theme.palette.common.black,
    color: theme.palette.common.black,
    flex: '0 1 100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.input.fontSize,
    [mq.sm.max]: {
      fontSize: theme.typography.input.fontSize
    },
    input: {
      background: theme.palette.common.white,
      borderColor: 'rgb(213, 213, 213)',
      borderImage: 'initial',
      borderRadius: '0.1875rem',
      borderStyle: 'solid',
      borderWidth: '0.0625rem',
      boxSizing: 'border-box',
      caretColor: theme.palette.common.black,
      color: 'rgb(127, 127, 127)',
      fontFamily: 'inherit',
      fontSize: '0.875rem',
      minHeight: '2.5rem',
      padding: '0.25rem 1.25rem',
      width: '100%',
    },
    label: {
      display: 'inline-block',
      marginBottom: '5px',
      maxWidth: '100%'
    },
    marginBottom: '10px',
    select: {
      background: theme.palette.common.white,
      borderColor: 'rgb(213, 213, 213)',
      borderImage: 'initial',
      borderRadius: '0.1875rem',
      borderStyle: 'solid',
      borderWidth: '0.0625rem',
      boxSizing: 'border-box',
      caretColor: theme.palette.common.black,
      color: 'rgb(127, 127, 127)',
      fontFamily: 'inherit',
      fontSize: '0.875rem',
      minHeight: '2.5rem',
      padding: '0.25rem 1.25rem',
      width: '100%',
    },
  },
  '.main-header': {
    backgroundColor: theme.palette.common.white,
    borderBottom: '1px solid rgb(213, 213, 213)',
    color: theme.palette.common.black,
    display: 'flex',
    flex: '0 0 auto',
    flexWrap: 'wrap',
    '.logo': {
      alignItems: 'center',
      boxSizing: 'inherit',
      display: 'flex',
      flex: '1 1 0%',
      height: '6.25rem',
      justifyContent: 'flex-start',
      marginLeft: '20%',
      paddingLeft: '20px',
    },
    overflowX: 'hidden',
    position: 'sticky',
    top: '0px',
    width: '100%',
    zIndex: 1000
  },
  option: {
    color: theme.palette.common.black
  },
  '.select-error': {
    borderColor: theme.palette.error.main + '!important'
  },
  '.spacer': {
    height: '30px'
  },
  '.svg-inline--fa': {
    color: theme.palette.error.main,
    display: 'inline-block',
    fontSize: 'inherit',
    height: '1em',
    marginRight: '0.5rem !important',
    width: '1em',
    verticalAlign: 'middle'
  },
  'button.primary': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  'button.secondary': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText
  },
  '.error': {
    borderColor: theme.palette.error.main + '!important',
    color: theme.palette.error.main + '!important'
  }
}));



// WEBPACK FOOTER //
// ./src/EnrollmentFormWrapper.tsx